
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/price-match",
      function () {
        return require("private-next-pages/price-match.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/price-match"])
      });
    }
  